import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { useQueryParams } from "src/hooks/useQueryParams";
import {
  selectorCategories,
  selectorIsLoadingCategories,
} from "src/redux/blog/selector";
import { getBlogCategoriesAsync } from "src/redux/blog/actions";
import { Loader } from "src/components/Loader";
import { Sizes } from "src/@types/sizes";
import { Category } from "./Category";
import { categoriesTrns } from "../../trns";
import { QueryParamKeys } from "../../types";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";

export const Categories: FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const categories = useAppSelector(selectorCategories);
  const isLoading = useAppSelector(selectorIsLoadingCategories);

  const categoriesResult = categories || [];

  useEffect(() => {
    dispatch(getBlogCategoriesAsync());
  }, [dispatch]);

  const { getQueryParam } = useQueryParams();

  const activeCategory =
    categoriesResult.find(
      ({ slug }) => slug === getQueryParam(QueryParamKeys.CATEGORY)
    ) || categoriesResult[0];

  return (
    <div className="flex-grow xl:max-w-100 w-full xl:sticky xl:top-25 h-max">
      <p className="hidden xl:block text-purple-base text-xl font-monument-extended font-semibold px-5 pb-5">
        {t(categoriesTrns.title)}
      </p>

      {isLoading ? (
        <div className="flex justify-center items-center w-full min-h-72">
          <Loader size={Sizes.XXL} />
        </div>
      ) : (
        <Swiper
          spaceBetween={8}
          slidesPerView="auto"
          direction="horizontal"
          breakpoints={{
            [SCREEN_BREAKPOINTS.XL]: {
              direction: "vertical",
              spaceBetween: 0,
              allowTouchMove: false,
            },
          }}
        >
          <ul>
            {categoriesResult.map((category) => (
              <SwiperSlide
                key={category.id}
                className="flex-shrink max-w-max xl:max-w-full whitespace-nowrap"
              >
                <Category activeCategory={activeCategory} category={category} />
              </SwiperSlide>
            ))}
          </ul>
        </Swiper>
      )}
    </div>
  );
};
